import { api, resolvePagination } from './api';

/**
 * Retrieve patient plans.
 */
export const getPlansTemplates = async (pageLimit, pageToken) => {
    const headers = resolvePagination(pageToken, pageLimit);
    return api.get('/cheart/plans', { headers });
};

/**
 * Create a new ConnectedHeart plan template.
 * @param {string} name - Plan name.
 * @param {string} description - Plan description.
 * @param {data} data - JSON plan definition.
 */
export const createPlan = async ({ name, description, data }) => {
    const response = await api.post('/cheart/plans', { name, description, data });
    return response.data;
};

/**
 * Delete a ConnectedHeart Plan.
 * @param {string} uuid - The unique identifier of the group to delete.
 */
export const deletePlan = async (uuid) => {
    const response = await api.delete('/cheart/plans', {
        data: { uuid }
    });
    return response.data;
};

/**
 * Fetch a ConnectedHeart Plan.
 * @param {string} uuid - The unique identifier of the plan.
 */
export const fetchPlanByUUID = async (uuid) => {
    const response = await api.post('/cheart/plans/fetch', { uuid });
    return response.data;
};

/**
 * Edit a ConnectedHeart plan template.
 * @param {string} uuid - The unique identifier of the plan to delete.
 * @param {string} name - Plan name.
 * @param {string} description - Plan description.
 * @param {data} data - JSON plan definition.
 */
export const editPlan = async (uuid, name, description, data) => {
    const response = await api.patch('/cheart/plans', {
        uuid,
        name,
        description,
        data
    });
    return response.data;
};

/**
 * Search a ConnectedHeart Plan with Query.
 * @param {string} query - An optional search query to filter plans.
 */
export const searchPlans = async (query = '') => {
    const response = await api.post('/cheart/plans/search', { query });
    return response.data;
};

/**
 * Assign a ConnectedHeart Plan to a Pacient.
 * @param {string} planUUID - The unique identifier of the plan.
 * @param {string} patientUUID - The unique identifier of the patient.
 * @param {object} startDate - The start date of the plan.
 * @param {object} endDate - The end date of the plan.
 * @param {object} options - The options of the plan.
 */
export const assignPlanToPatient = async (
    planUUID,
    patientUUID,
    startDate,
    endDate,
    options = null
) => {
    const payload = {
        plan: planUUID,
        patients: [patientUUID],
        start_date: startDate,
        end_date: endDate,
        ...(options && { options })
    };

    const response = await api.post('/cheart/plan/assign/patients', payload);
    return response.data;
};

/**
 * Assign a ConnectedHeart Plan to a Group.
 * @param {string} planUUID - The unique identifier of the plan.
 * @param {string} groupUUID - The unique identifier of the group.
 * @param {object} startDate - The start date of the plan.
 * @param {object} endDate - The end date of the plan.
 * @param {object} options - The options of the plan.
 */
export const assignPlanToGroup = async (
    planUUID,
    groupUUID,
    startDate,
    endDate,
    options = null
) => {
    const payload = {
        plan: planUUID,
        group: groupUUID,
        start_date: startDate,
        end_date: endDate,
        ...(options && { options })
    };

    const response = await api.post('/cheart/plan/assign/group', payload);
    return response.data;
};
